import { useTranslation } from 'react-i18next';
import { allocationService } from '../services/allocationService';
import type { ScopedExportRequest } from '../types/Filters';
import type { SummaryFilters } from '../types/Summary';
import { useSpreadsheetExport } from './useSpreadsheetExport';

/** A síntese não pagina: a exportação leva sempre toda a matriz, sem escopo de página. */
export function useExportSummary(filters: SummaryFilters) {
  const { t } = useTranslation('alocacao');
  return useSpreadsheetExport<ScopedExportRequest>(
    ({ format, language }) => allocationService.exportSummary(filters, { format, language }),
    t('consultas.sintese.nomeArquivo'),
  );
}
